<template>
  <div id="dashboard" v-if="$store.state.auth.uid" class="p8">
    <div class="flex between align-center dashboard_header">
      <h1>Dashboard</h1>
      <div>
        <button
          class="xs-font"
          @click="$store.dispatch('auth', { type: 'logout' })"
          type="button"
        >
          Logout
        </button>
      </div>
    </div>
    <div v-if="$store.state.auth && $store.state.orders" class="flex wrap">
      <div class="sub-container dashboard_container order_history">
        <b>Order History</b>
        <div
          class="b8 xs-font dashboard_order_history_order"
          v-for="order in Object.entries($store.state.orders).filter(
            (x) => x[1].complete
          )"
          :key="order[0]"
        >
          <div class="flex between">
            <itime :timestamp="order[1].timestamp" />
            <span class="r4 l4">
              Order ID
              <router-link :to="`/orders/${order[0]}`" class="update-text">{{
                order[0]
              }}</router-link>
            </span>
            <span>
              Total
              <b class="indicate-text">${{ order[1].total }}</b>
            </span>
          </div>
          <div class="flex">
            <b>Items:</b>
            <span
              class="l8"
              v-for="(item, itemkey) in order[1].items"
              :key="itemkey"
            >
              <router-link :to="`/i/${item.type}/${item.iitemid}`"
                >{{ item.qty }} {{ item.itemTitle }}</router-link
              >
            </span>
          </div>
        </div>
      </div>
      <div class="sub-container dashboard_container dashboard_assets">
        <b>Your items</b>
        <div
          class="dashboard_assets_order"
          v-for="(order, orderid) in $store.state.orders"
          :key="orderid"
        >
          <div
            class="dashboard_assets_order_item"
            v-for="(item, itemkey) in order.items"
            :key="itemkey"
          >
            <router-link
              v-if="item.purchase.ownership"
              :to="`/i/${item.type}/${item.iitemid}`"
              >{{ item.itemTitle }}</router-link
            >
          </div>
        </div>
      </div>
      <div class="sub-container dashboard_container xs-font dashboard_billing">
        <b>Billing Cycle</b>
        <div class="p4 container flex between">
          <b>Item</b>
          <b>Days left</b>
        </div>
        <div
          class="dashboard_billing_order"
          v-for="(order, orderid) in $store.state.orders"
          :key="orderid"
        >
          <div
            class="dashboard_billing_order_item"
            v-for="(item, itemkey) in order.items"
            :key="itemkey"
          >
            <div
              v-if="item.purchase.subscription"
              class="container flex around"
            >
              <router-link class="p4" :to="`/i/${item.type}/${item.iitemid}`">{{
                item.itemTitle
              }}</router-link>
              <code class="p4">
                {{
                  Math.floor(
                    (Date.now() - (order.timestamp + 31540000000)) *
                      -0.0000000115741 -
                      1
                  )
                }}
              </code>
            </div>
          </div>
        </div>
        <!-- subscribe prop -->
      </div>
      <div class="sub-container dashboard_container dashboard_neworder">
        <b>New Order</b>
      </div>
      <div class="sub-container dashboard_container dashboard_open_orders">
        <b>Open Orders</b>
        <div
          class="b8 xs-font dashboard_open_orders_order"
          v-for="order in Object.entries($store.state.orders).filter(
            (x) => !x[1].complete
          )"
          :key="order[0]"
        >
          <div class="flex between">
            <itime :timestamp="order[1].timestamp" />
            <span class="r4 l4">
              Order ID
              <router-link :to="`/orders/${order[0]}`" class="update-text">{{
                order[0]
              }}</router-link>
            </span>
            <span>
              Total
              <b class="indicate-text">${{ order[1].total }}</b>
            </span>
          </div>
          <div class="flex">
            <b>Items:</b>
            <span
              class="l8 dashboard_open_orders_item"
              v-for="(item, itemkey) in order[1].items"
              :key="itemkey"
            >
              <router-link :to="`/i/${item.type}/${item.iitemid}`"
                >{{ item.qty }} {{ item.itemTitle }}</router-link
              >
            </span>
          </div>
        </div>
      </div>
    </div>
    <div
      class="sub-container dashboard_container h-scroll dashboard_sales"
      v-if="Object.keys($store.state.sales).length > 0"
    >
      <b>Sales</b>
      <sales />
    </div>
    <div class="flex">
      <div v-if="logs.emails">
        <h4>Emails sent</h4>
        <div
          class="container p4 xs-font"
          v-for="(email, emailkey) in logs.emails"
          :key="emailkey"
        >
          <div
            @click="$set(show, 'email' + emailkey, !show['email' + emailkey])"
          >
            <itime :timestamp="email.timestamp" />
            <b>{{ email.to[0].address }} </b>
          </div>
          <div v-if="show['email' + emailkey]">
            {{ email.text || email.html }}
          </div>
        </div>
      </div>
      <div v-if="logs.webhooks">
        <h4>Webhooks</h4>
        <div
          class="container p4 xs-font"
          v-for="(hook, hookkey) in logs.webhooks"
          :key="hookkey"
        >
          <itime :timestamp="hook.timestamp" />
          <div
            @click="$set(show, 'hook' + hookkey, !show['hook' + hookkey])"
            class=""
          >
            <b>{{ hook.action }}</b> <i>{{ hook.resource_type }}</i>
            <span>[ {{ hook.id }} ]</span>
          </div>
          <code v-if="show['hook' + hookkey]">{{ hook }}</code>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <login />
  </div>
</template>
<script>
export default {
  name: "dashboard",
  data() {
    return {
      user: {},
      total: {
        orders: 0,
        sales: 0,
        shipping: 0,
      },
      orderlist: [],
      items: [],
      logs: {},
      show: {},
    };
  },
  methods: {
    totals(obj, type) {
      if (type !== "orders" || type !== "sales") {
        return false;
      }
      Object.keys(obj).forEach((objItems) => {
        if (type === "orders") {
          if (!obj[objItems]) {
            return console.log("No orders");
          }
          obj[objItems].paid
            ? (this.total[type] =
                Number(this.total[type]) + Number(obj[objItems].total))
            : void 0;
        } else if (type === "sales") {
          if (!obj[objItems]) {
            return console.log("No sales");
          }
          obj[objItems].paid
            ? obj[objItems].forEach((objItem) => {
                this.total[type] =
                  +this.total[type] + +objItem.purchase.cost * +objItem.qty;
                this.total.shipping =
                  +this.total.shipping +
                  +objItem.purchase["shipping and handling"];
              })
            : void 0;
        }
      });
    },
  },
  created() {
    let hook = this.$store.state.app.advanced.hooks.dashboard;
    hook &&
      this.$store.dispatch("run", {
        from: "Dashboard",
        if: hook.if || [],
        fun:hook.fun,
        payload: hook.getpayload || hook.payload ||{},
      });
  },
  mounted() {
    (async () => {
      this.logs = await this.$store
        .dispatch("query", { type: "logs" })
        .then((x) => x);
      await this.$store
        .dispatch("query", {
          type: "user",
          id: this.$store.state.auth.uid,
        })
        .then(async () => {
          await this.$store
            .dispatch("query", {
              type: "orders",
              user: this.$store.state.auth.uid,
            })
            .then(async () => {
              console.log(
                "have no items?",
                Object.entries(this.$store.state.orders)
              );
              this.totals(this.$store.state.orders, "orders");
              let items = [];
              Object.entries(await this.$store.state.orders).forEach(
                (order) => {
                  console.log("get items", order);
                  order[1].items.forEach((item) => {
                    item.purchase.ownership ? items.push(item.iitemid) : null;
                  });
                }
              );
              return (this.items = items);
            });
          await this.$store
            .dispatch("query", {
              type: "sales",
              user: this.$store.state.auth.uid,
            })
            .then(() => {
              this.totals(this.$store.state.sales, "sales");
            });
          return true;
        });
    })();
  },
};
</script>